import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const AwardsAndCertificationsSection = () => {
  const { language } = useLanguage();
  const [activeTab, setActiveTab] = useState('certifications');

  const certifications = [
    {
      name: {
        fr: 'Certifiés sur les produits Panametrics',
        ar: 'معتمدون على منتجات Panametrics',
        en: 'Certified on Panametrics products'
      },
      description: {
        fr: 'Notre équipe est certifiée pour l\'installation, la maintenance et la calibration des produits Panametrics, garantissant un service de la plus haute qualité pour ces instruments de mesure de précision.',
        ar: 'فريقنا معتمد لتركيب وصيانة ومعايرة منتجات Panametrics، مما يضمن خدمة بأعلى جودة لأدوات القياس الدقيقة هذه.',
        en: 'Our team is certified for the installation, maintenance and calibration of Panametrics products, ensuring the highest quality service for these precision measurement instruments.'
      },
      year: '2023',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      color: '#38A169'
    },
    {
      name: {
        fr: 'Certifiés sur les produits Hobré',
        ar: 'معتمدون على منتجات Hobré',
        en: 'Certified on Hobré products'
      },
      description: {
        fr: 'Nous sommes certifiés pour travailler avec les solutions d\'analyse Hobré, offrant une expertise spécialisée dans l\'installation et la maintenance de ces systèmes d\'analyse avancés pour le secteur Pétrole, Gaz et Industrie.',
        ar: 'نحن معتمدون للعمل مع حلول تحليل Hobré، مما يوفر خبرة متخصصة في تركيب وصيانة أنظمة التحليل المتقدمة هذه لقطاع النفط والغاز والصناعة.',
        en: 'We are certified to work with Hobré analyzer solutions, offering specialized expertise in the installation and maintenance of these advanced analysis systems for the Oil, Gas and Industry sector.'
      },
      year: '2023',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      color: '#3182CE'
    },
    {
      name: {
        fr: 'Certifiés sur les produits Masoneilan',
        ar: 'معتمدون على منتجات Masoneilan',
        en: 'Certified on Masoneilan products'
      },
      description: {
        fr: 'Notre équipe est certifiée pour l\'installation et la maintenance des vannes de régulation Masoneilan, assurant des performances optimales et une fiabilité maximale pour ces composants critiques des systèmes de contrôle de processus.',
        ar: 'فريقنا معتمد لتركيب وصيانة صمامات التحكم Masoneilan، مما يضمن الأداء الأمثل والموثوقية القصوى لهذه المكونات الحاسمة في أنظمة التحكم في العمليات.',
        en: 'Our team is certified for the installation and maintenance of Masoneilan control valves, ensuring optimal performance and maximum reliability for these critical components of process control systems.'
      },
      year: '2023',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      color: '#805AD5'
    }
  ];

  const awards = [];

  const getLanguageText = (textObj) => {
    return textObj[language] || textObj.fr || textObj.en;
  };

  return (
    <section className="section section-dark" style={{ 
      position: 'relative',
      padding: '6rem 0',
      overflow: 'hidden'
    }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '5%',
        left: '0%',
        width: '300px',
        height: '300px',
        borderRadius: '43% 57% 70% 30% / 30% 36% 64% 70%',
        background: 'linear-gradient(45deg, rgba(255, 107, 0, 0.03) 0%, rgba(255, 215, 0, 0.03) 100%)',
        animation: 'blob-animation 25s linear infinite',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '5%',
        right: '0%',
        width: '250px',
        height: '250px',
        borderRadius: '70% 30% 30% 70% / 60% 40% 60% 40%',
        background: 'linear-gradient(45deg, rgba(255, 107, 0, 0.03) 0%, rgba(255, 215, 0, 0.03) 100%)',
        animation: 'blob-animation-reverse 20s linear infinite',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ 
        position: 'relative', 
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem'
      }}>
        {/* Section header */}
        <div style={{
          textAlign: 'center',
          marginBottom: '4rem'
        }}>
          <span style={{
            display: 'inline-block',
            padding: '0.5rem 1.5rem',
            backgroundColor: 'rgba(255, 107, 0, 0.1)',
            color: 'var(--assco-orange)',
            borderRadius: '30px',
            fontWeight: '600',
            fontSize: '0.875rem',
            marginBottom: '1rem',
            textTransform: 'uppercase'
          }}>
            {language === 'fr' ? 'RECONNAISSANCES' : 
             language === 'ar' ? 'التقدير' : 
             'RECOGNITIONS'}
          </span>

          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '1.5rem',
            color: 'white',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Certifications' : 
             language === 'ar' ? 'الشهادات' : 
             'Certifications'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          <p style={{
            fontSize: '1.125rem',
            color: 'rgba(255, 255, 255, 0.8)',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Notre engagement envers l\'excellence et la qualité a été reconnu par de nombreuses organisations industrielles et organismes de certification.' 
              : language === 'ar'
              ? 'تم الاعتراف بالتزامنا بالتميز والجودة من قبل العديد من المنظمات الصناعية وهيئات الاعتماد.'
              : 'Our commitment to excellence and quality has been recognized by numerous industrial organizations and certification bodies.'}
          </p>
        </div>
        
        {/* Tab navigation */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '3rem'
        }}>

        </div>
        
        {/* Content */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
          gap: '2rem'
        }}>
          {(activeTab === 'certifications' ? certifications : awards).map((item, index) => (
            <div 
              key={index}
              className="fade-in"
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '1.25rem',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                overflow: 'hidden',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                transition: 'all 0.3s ease',
                animationDelay: `${0.1 * index}s`,
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
                e.currentTarget.style.borderColor = item.color;
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.3)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
              }}
            >
              {/* Header */}
              <div style={{
                padding: '1.5rem',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '1rem'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem'
                }}>
                  <div style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '12px',
                    backgroundColor: `${item.color}10`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: item.color
                  }}>
                    <div style={{ width: '24px', height: '24px' }}>
                      {item.icon}
                    </div>
                  </div>
                  <div>
                    <h3 style={{
                      fontSize: '1.125rem',
                      fontWeight: '600',
                      color: 'white',
                      margin: 0
                    }}>
                      {getLanguageText(item.name)}
                    </h3>
                  </div>
                </div>
                <div style={{
                  backgroundColor: item.color,
                  color: 'white',
                  fontWeight: '600',
                  fontSize: '0.875rem',
                  padding: '0.25rem 0.75rem',
                  borderRadius: '100px'
                }}>
                  {item.year}
                </div>
              </div>
              
              {/* Content */}
              <div style={{
                padding: '1.5rem',
                flex: 1
              }}>
                <p style={{
                  fontSize: '1rem',
                  lineHeight: '1.6',
                  color: 'rgba(255, 255, 255, 0.75)',
                  margin: 0
                }}>
                  {getLanguageText(item.description)}
                </p>
              </div>
              
              {/* Footer */}
              <div style={{
                padding: '1rem 1.5rem',
                backgroundColor: `${item.color}05`,
                borderTop: '1px solid #e2e8f0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end'
              }}>
                <button
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    backgroundColor: 'transparent',
                    color: item.color,
                    border: 'none',
                    padding: '0.5rem',
                    borderRadius: '0.375rem',
                    fontWeight: '600',
                    fontSize: '0.875rem',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = `${item.color}10`;
                    e.currentTarget.style.gap = '0.75rem';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = 'transparent';
                    e.currentTarget.style.gap = '0.5rem';
                  }}
                >
                  {language === 'fr' ? 'En savoir plus' : 
                   language === 'ar' ? 'معرفة المزيد' : 
                   'Learn more'}
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AwardsAndCertificationsSection;
